/** ApiError carries the backend's status and error code for typed handling. */
export class ApiError extends Error {
    status;
    code;
    /** The decoded error body (when the backend sent JSON), for codes that carry extra fields. */
    body;
    constructor(status, code, message, body = null) {
        super(message);
        this.name = "ApiError";
        this.status = status;
        this.code = code;
        this.body = body;
    }
    get isUnauthorized() {
        return this.status === 401;
    }
    get isValidation() {
        return this.code === "validation_error";
    }
}
/** User-facing message from bridge/API failures. */
export function errorMessage(err, fallback) {
    if (err instanceof ApiError || err instanceof Error)
        return err.message;
    return fallback;
}
/** Thrown by `login()` when the backend asks the user to pick a site (no tokens issued). */
export class SiteChoiceRequiredError extends ApiError {
    sites;
    constructor(sites) {
        super(300, "SITE_CHOICE_REQUIRED", "choose a site to sign in to");
        this.name = "SiteChoiceRequiredError";
        this.sites = sites;
    }
}
const TABLE_TAB_CODES = ["tab_already_open", "connect_not_ready", "version_conflict", "checkout_disabled"];
/** Narrows an ApiError to one of the dining tab codes (#1413); null for anything else. */
export function tableTabErrorCode(err) {
    if (!(err instanceof ApiError))
        return null;
    return TABLE_TAB_CODES.includes(err.code) ? err.code : null;
}
//# sourceMappingURL=errors.js.map